import {createSlice} from  '@reduxjs/toolkit';

const initialState = {
    isloading:false,
    umstatus:"",
    ummessage:"",
    error:"",
    user: {},
    usstatus:"",
    usmessage:"",
    userSDetail:{}
};

const userModifySlice = createSlice({
    name:"userModify",
    initialState,
    reducers:{
        modifyPending: (state,action) =>{
            state.isloading=true;
            state.umstatus=""
        },
        modifySuccess: (state,{payload}) =>{
            state.isloading=false;
            state.umstatus="success";
            state.ummessage=payload;
            console.log(payload);
        },
        modifyFail: (state,{payload}) =>{
            
            state.isloading=false;
            state.umstatus="fail";
            state.ummessage=payload;
            // state.message=payload.message;
            // state.error=payload.error;
            console.log(payload);
        },
        getSUserPending: (state,action) =>{
            state.isloading=true;
        },
        getSUserSuccess: (state,{payload}) =>{
            state.isloading=false;
            state.userSDetail=payload;
        },
        getSUserFail: (state,{payload}) =>{
            state.isloading=false;            
            state.error=payload.error;
        },
    }
});


const {reducer, actions} = userModifySlice;
export const {modifyPending,modifySuccess,modifyFail,getSUserPending,getSUserSuccess,getSUserFail} =actions;
export default reducer;
